export class Event {
    public id: string;
    public name: string;
    public documentName: string;
    public documentType: string;
    public iconClass?: string;
    public date: Date;
    public category: string;
    public party: string;
    public additionalInfo?: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/model/event.model.ts